import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Anime%20style%20artwork%20with%20vibrant%20colorful%20sky%20at%20sunset%2C%20silhouette%20of%20city%20skyline%2C%20cherry%20blossom%20petals%20floating%2C%20dreamy%20and%20warm%20atmosphere%2C%20soft%20gradient%20from%20warm%20orange%20to%20soft%20pink%2C%20anime%20background%20illustration%2C%20cinematic%20composition%2C%20beautiful%20scenery&width=1600&height=900&seq=hero-bg-anime-2024&orientation=landscape"
        alt="奶泡动漫 - 高品质动漫在线观看平台背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 md:mb-6 leading-tight">
          探索动漫的无限世界
        </h1>
        <p className="text-sm md:text-lg text-background-100/90 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed">
          海量日漫国漫番剧资源，高清流畅播放，让每一次追番都成为享受
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-xl text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-play-circle-fill mr-2"></i>
            立即开始追番
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-xl text-base font-medium hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-3 gap-4 md:gap-8 max-w-lg mx-auto">
          {[
            { value: '5000+', label: '番剧资源' },
            { value: '1080P+', label: '高清画质' },
            { value: '300万+', label: '动漫同好' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-3xl font-bold text-background-50">{stat.value}</div>
              <div className="text-xs md:text-sm text-background-200/80 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}